'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Combines an array of media queries into a single comma-delimited
 *   list of queries and only keeps the first instance of the "@media"
 *   prefix.
 *
 * See also: {@link https://developer.mozilla.org/en-US/docs/Web/CSS/Media_Queries/Using_media_queries#testing_for_multiple_queries}
 */
var combineMediaQueries = function combineMediaQueries(mediaQueries) {
  return mediaQueries.length > 0 ? "@media ".concat(mediaQueries.join(', ').replace(/@media /g, '')) : '';
};

exports.combineMediaQueries = combineMediaQueries;
//# sourceMappingURL=index.js.map
